export const SET_MAP_SQUARES = 'SET_MAP_SQUARES';
export const UPDATE_MAP_SQUARES = 'UPDATE_MAP_SQUARES';
export const SET_MAP_MISSIONS = 'SET_MAP_MISSIONS';
